import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import styles from "./tab-header.less"
import jss from "jss"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import { toJss, darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"

class TabHeader extends C {
  static dynamicStyles = null
  static displayName = "TabHeader"
  static propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
    handleClick: PropTypes.func,
    isActive: PropTypes.bool,
    readable: PropTypes.bool,
    disabled: PropTypes.bool,
    additionalActiveClass: PropTypes.string,
    dataQa: PropTypes.string,
  }

  constructor(props) {
    super(props)

    if (TabHeader.dynamicStyles == null) {
      const dynamicStylesConfig = toJss((props.skinObject.tabsV2 || {}).header || {}, {
        tab: {
          handler: {
            color: v.gray500,
          },
          m_active: {
            handler: {
              color: v.black,
            },
          },
        },
        innerTab: {
          handler: {
            color: v.darkBlue400,
          },
        },
      })

      TabHeader.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  handleClick(e) {
    e.preventDefault()
    this.props.handleClick()
  }

  getClass() {
    let { classes } = TabHeader.dynamicStyles

    return classnames(
      {
        [styles.tab]: this.props.type !== "inner",
        [classes.tab]: this.props.type !== "inner",
        [styles.innerTab]: this.props.type === "inner",
        [classes.innerTab]: this.props.type === "inner",
        [styles.active]: this.props.isActive,
        [classes.active]: this.props.isActive,
        [styles.disabled]: this.props.disabled,
        [this.props.additionalActiveClass]: this.props.isActive,
        "readspeaker-readable-area": this.props.readable,
      },
      this.props.className,
    )
  }

  render() {
    let { classes } = TabHeader.dynamicStyles

    return (
      <div className={this.getClass()}>
        <a
          data-qa={this.props.dataQa}
          onClick={
            this.props.handleClick != null
              ? (e) => {
                  e.preventDefault()
                  this.props.handleClick(e)
                }
              : null
          }
          href={this.props.url}
          className={classnames(styles.handler, classes.handler, "rs_preserve")}>
          {this.props.children}
        </a>
      </div>
    )
  }
}

export default withSkin(TabHeader)
